import { render, staticRenderFns } from "./BranchEdit.vue?vue&type=template&id=f9c61afe"
import script from "./BranchEdit.vue?vue&type=script&lang=ts"
export * from "./BranchEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports